import { render, staticRenderFns } from "./Autocorre.vue?vue&type=template&id=b901bb28&scoped=true&"
import script from "./Autocorre.vue?vue&type=script&lang=js&"
export * from "./Autocorre.vue?vue&type=script&lang=js&"
import style0 from "./Autocorre.vue?vue&type=style&index=0&id=b901bb28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b901bb28",
  null
  
)

export default component.exports